<template>
    <slot v-if="isVisible" />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { breakpointsTailwind, useBreakpoints } from '@vueuse/core'
import type { ScreenProps } from './types'

const props = defineProps<ScreenProps>()

const breakpoints = useBreakpoints(breakpointsTailwind)

const isVisible = computed(() => {
    if (props.above && props.below) {
        return breakpoints.between(props.above, props.below).value
    }

    if (props.above) {
        return breakpoints.greaterOrEqual(props.above).value
    }

    if (props.below) {
        return breakpoints.smaller(props.below).value
    }

    // No props specified - always visible
    return true
})
</script>
